import axiosInstance from './axiosInstance';

export async function getDrivers(page = 1, limit = 10) {
  const response = await axiosInstance.get('/drivers/get-drivers.php', {
    params: { page, limit },
  });
  return response.data;
}

export async function createDriver(driverData) {
  const response = await axiosInstance.post('/drivers/create-driver.php', driverData);
  return response.data;
}

export async function getDriverDetail(id) {
  const response = await axiosInstance.get(`/drivers/get-driver-detail.php?id=${id}`);
  return response.data;
}

export async function editDriver(driverData) {
  const response = await axiosInstance.post('/drivers/edit-driver.php', driverData);
  return response.data;
}

export async function deactivateDriver(id, isActive) {
  const response = await axiosInstance.post('/drivers/deactivate-driver.php', {
    id_driver: id,
    is_active: isActive,
  });
  return response.data;
}





// driversApi.js
export async function searchDrivers(query) {
  const response = await axiosInstance.get('/drivers/search-drivers.php', { params: { q: query } });
  return response.data.success ? response.data.drivers : [];
}